import React, { Component } from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import {Howl, Howler} from 'howler';

import './Ecran180.css';
import './transitions.css';

import TempoVeille from './TempoVeille'
import EcranVeille from './EcranVeille'
import EcranMenu from './EcranMenu'
//import EcranVideo from './EcranVideo'
import VideoPlayer from './VideoPlayer'
import TitragesAnims from './TitragesAnims'
import Markers from './Markers'
import BasedocPopup from './BasedocPopup'
import Interaction from './Interaction'

/* Partie APP 
   qui gère l'écran de veille, le chargement des donnees, la machine à état, etc.
*/ 

// ELECTRON SPECIFIC
const isElectron = typeof window.require !== "undefined";  


window._DEBUG_TOUCH = false;

class Ecran180 extends Component {

  constructor(props) {

    super(props);

    this.state = {
      enVeille: true,
      menuOpen: false,
      resetTempoVeilleData:0,
      /* */
      currentState: false,
      currentChapitre: false,
       /* */
      currentVideo: false,
      onEndVideo: null, 
      onReadyVideo: null,
      loop: false,
      /* */
      titragesAnims : false,
      /* */ 
      interaction: false,
      interactionAction: null,
      callBackSendPosition: false,  /* utilisé par les basedocmarker */
      /* markers */
      basedoc: false,
      positionTime: false,
      baseDocMarkers: [],  
      /* popup base doc */ 
      basedocPopupOpen: false,    
      popupContent: false,
      
      /* pour la fenètre, intégrée dans l'app responsive */
      scale : 1.0,
      translate : {x:0, y: 0},
      isPortrait: false,
      isFullScreen : false
    }


  }


  setScalePosition = (w, h) =>
  {

    const ratio = w / h;
    let scale = 0;
    if(ratio <= 16/9 )  // écran 4/3
    {
      scale = w / 1920;
    }else // écran 20/9
    {
      scale = h / 1080;
    }

    const tranform_x = ( (w - 1920 * scale) / 2 ).toFixed();
    const tranform_y = ( (h - 1080 * scale) / 2 ).toFixed();

    this.setState( { translate : { x: tranform_x, y :tranform_y }, scale : scale })

    this.props.logFn("setScalePosition() "+w +"px,"+ h + "px, ratio:"+ratio+ ", scale:"+scale+", translate:"+tranform_x+"px,"+tranform_y+"px");
    
  }


  changeFullscreen = () => {

    this.props.logFn("changeFullscreen()");

    const el = document.documentElement;

    /*  FULLSCREEN OR NOT ?*/
    if(el.requestFullscreen && !this.state.isFullScreen) {
      this.props.logFn("changeFullscreen : requestFullscreen");
      el.requestFullscreen().then({}).catch(err => {
        this.props.logFn(`changeFullscreen() requestFullscreen() Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
      });
    }
    if (document.exitFullscreen && this.state.isFullScreen) {
      this.props.logFn("changeFullscreen : exitFullscreen");
      document.exitFullscreen(); 
    }    
    
/*    
    else if(el.mozRequestFullScreen) { // normalement géré par Babel.js >> à vérifier
      el.mozRequestFullScreen();
    } else if(el.webkitRequestFullscreen) {
      el.webkitRequestFullscreen();
    } else if(el.msRequestFullscreen) {
      el.msRequestFullscreen();
    }
*/
    /* calcul d'un scale, pour passer du fixed 1920/1080 à la taille de l'écran */
    /* après le fullscreen pour avoir le bon inneWidth */
    
    document.addEventListener("fullscreenchange", ( event ) => {
      
        if ( document.fullscreenElement )  //ou ?   document.fullscreen, pas clair selon Mozilla
        {
          this.setState( { isFullScreen  : true }); 
          // ? cas particulier, on utilise le window.screen car il semble que le fullscreenchange n'a pas eu le temps d'inité le window.innerWidth ?
          this.setScalePosition(window.screen.width, window.screen.height);
        }
        else
        {
          this.setState( { isFullScreen  : false }); 
          this.setScalePosition(window.innerWidth, window.innerHeight);
        }

        this.props.logFn("changeFullscreen():: fullscreenchange event:"+ (document.fullscreenElement!=null) );

        
    
    });

  }

  screenChangeOrientation = (e) =>
  {
    if (e.matches) {
      //console.log("portrait");
      this.setState( { isPortrait : true } );
    }else
    {
      //console.log("pas portrait");
      this.setState( { isPortrait : false } );
    }
    
    this.setScalePosition(window.innerWidth, window.innerHeight);
  }     

  componentDidMount() 
  {

    window.addEventListener('resize', (e) =>
    {
        if (this.resizeTaskId !== null) {
          clearTimeout(this.resizeTaskId);
        }
        this.resizeTaskId = setTimeout(() => {
          this.resizeTaskId = null;
          this.setScalePosition(window.innerWidth, window.innerHeight);
        }, 100);  // 100ms de delay pour éviter le throttle de l'event 
    });

    window.addEventListener('touchmove', (e) =>
    {
        /* ??? */
        e.preventDefault();    
    });

    /* calcul d'un scale par défaut , pour passer du fixed 1920/1080 à la taille de l'écran */
    /* si le fullscreen ne marche pas, on sera qd même adapté */

    this.setScalePosition(window.innerWidth, window.innerHeight);

    this.setState( { isPortrait : window.matchMedia("all and (orientation: portrait)").matches } );

    const mql = window.matchMedia("all and (orientation: portrait)");
    mql.addListener(this.screenChangeOrientation);

    const chapitres = window.g_DATA_CONFIG;    
    this.setState( { currentChapitre: chapitres[0] } );

    this.initSounds();
    
    // Launch fullscreen for browsers that support it!
    //this.changeFullscreen(); // the whole page    


    if(!isElectron)
      this._sortieDeVeille();

/*
    NE MARCHE PAS -- EXCEPTION
    const screen = window.screen;
    if(screen)
    {
      //console.log(screen);
      // screen.orientation.lock = Chrome
      // screen.lockOrientation || screen.mozLockOrientation || screen.msLockOrientation = IE, Firefox
      // Safari ?
      const lockOrientationUniversal = screen.lockOrientation || screen.mozLockOrientation || screen.msLockOrientation || screen.orientation.lock;
      if(lockOrientationUniversal)
      {
        try {
          lockOrientationUniversal("landscape");//.then(() => {    console.log("Lock orientation : ok");     });                
        }catch(error) {
          console.error("Lock orientation error:",error);
        }
        
      }else
      {
        console.log("no lockOrientation interface");
      }
    }else
    {
      console.log("no screen interface");
    }*/
    
  }

  componentWillUnmount() {

    // par exemple, clearInterval
  }  

  callBackSendPosition(v)
  {
    //console.log(this);
    this.setState( { positionTime : v } );
    this.forceUpdate();
  }


  render() {

    const { scale, translate, isPortrait, enVeille, menuOpen, currentState, isFullScreen } = this.state;    

    const { tempo_veille, tempo_alerte_veille } = this.props.config;

    // for 'Animation' et 'Boucle'
    const { currentVideo, onEndVideo, onReadyVideo, loop } = this.state;    
    const { interaction, interactionAction } = this.state;    
    const { baseDocMarkers, basedoc, basedocPopupOpen, popupContent } = this.state;    
    const { titragesAnims } = this.state;

    const { appVersion } = this.props;

    /* scale et repositionnement */
    const scale_style = { transformOrigin: translate.x+"px "+translate.y+"px",
                          transform: "scale("+scale+") translate("+translate.x+"px,"+translate.y+"px)" };
  
    return (
      <div className="Ecran180" ref="Ecran180" style={ scale_style} onClick={this._resetTempoVeille} onTouchMove={this._resetTempoVeille} onTouchStart={this._resetTempoVeille} > 

{ /* interaction ? undefined : (menuOpen | basedocPopupOpen | enVeille */ }
        <VideoPlayer key='MainVideo' menuOpen={ menuOpen | basedocPopupOpen | enVeille } src={currentVideo} loop={ loop } onReadyVideo={ onReadyVideo } onEndVideo={ interaction ? false : onEndVideo } logFn={this.props.logFn} ></VideoPlayer>

        <CSSTransitionGroup component="div" transitionName="fadetransition" transitionAppear={true} transitionAppearTimeout={1000} transitionEnterTimeout={1000} transitionLeaveTimeout={250} >    
          { interaction && <Interaction key='interaction' scale={ scale } id={ currentState.id } menuOpen={ menuOpen | basedocPopupOpen | enVeille } onEnd={ interactionAction } callBackSendPosition={ (v)=> { this.callBackSendPosition(v); } } logFn={ this.props.logFn }></Interaction>}
        </CSSTransitionGroup>        

        { titragesAnims && <TitragesAnims ta= { titragesAnims } id={ currentState.id } logFn={ this.props.logFn }></TitragesAnims> }
        
        { basedoc && <Markers markers={ baseDocMarkers } positionTime={ this.state.positionTime } logFn={ this.props.logFn }></Markers> }

        <CSSTransitionGroup component="div" transitionName="fadetransition" transitionAppear={true} transitionAppearTimeout={1000} transitionEnterTimeout={1000} transitionLeaveTimeout={250} >    
          { basedocPopupOpen && <BasedocPopup key='basedocpopup' popupContent={ popupContent} onExitBasedocPopup={ this._onExitBasedocPopup }></BasedocPopup>}
        </CSSTransitionGroup>        

        <Timeline state={ currentState.id }  /> 
        
        <CSSTransitionGroup component="div" transitionName="apparitionMenu" transitionAppear={true} transitionAppearTimeout={250} transitionEnterTimeout={250} transitionLeaveTimeout={250} >    
          { menuOpen && <EcranMenu key='EcranMenu' logFn={this.props.logFn} currentId={ currentState.id } gotoAppState={ this.gotoAppState } onClickMenuTriangle={ this._onClickCloseMenu }  /> }
        </CSSTransitionGroup>        
        { !menuOpen && <ButtonMenu key='ButtonMenu' onClick={this._onClickMenu}/> }
        
        { isPortrait && <div className="popupTourner"><p>Tourner votre écran !</p></div>  }
        { enVeille && <EcranVeille key='EcranVeille' appVersion={ appVersion } onClick={this._sortieDeVeille} logFn={this.props.logFn}/> }
        { (!enVeille && isElectron ) && <TempoVeille key={this.state.resetTempoVeilleData} logFn={this.props.logFn} tempo_veille={tempo_veille} tempo_alerte_veille={tempo_alerte_veille} onVeille={this._entreeEnVeille} />  }

        { isFullScreen && <div className="iconFullscreen iconFullscreenOff" onClick={this.changeFullscreen}></div> }
        { !isFullScreen && <div className="iconFullscreen" onClick={this.changeFullscreen}></div> }

      </div>
    );    

  }


  /* -------------------- */



  gotoAppState = ( st ) =>  /* From MAIN MENU et _sortieDeVeille() */
  {
    this.props.logFn("App:gotoAppState(): "+st);
    
    const chapitres = window.g_DATA_CONFIG;

    for(let c in chapitres)
    {
      let entries = chapitres[c].entries; 

      for(let e in entries)
      {
        if( entries[e].id == st)
        {
          this.props.logFn("  App:gotoAppState:currentChapitre = "+chapitres[c].num+" currentState = "+entries[e].id);

          this.cleanState();
          this.doAppState( { c: chapitres[c], e:entries[e] } , true );  // true = reset <EcranVideo>
        }
      }
    }
  }


  /* récupère l'état suivant, ou cherche l'état après 'searchId' */
  /* animation permet de chercher uniquements dans les anims */

  getNextState = ( searchId , animation) =>
  {
    this.props.logFn("App:getNextState()");

    const chapitres = window.g_DATA_CONFIG;

    const { currentState } = this.state;    
    let _id = currentState.id
    if(searchId) _id = searchId;

    this.props.logFn("  App:getNextState after id : "+_id);

    let _s = false;

    // chapitres
    for(let c=0;c<chapitres.length;c++)
    {
      //console.log("## "+chapitres[c].num );
      var entries = chapitres[c].entries;

      // états
      for(let i=0;i<entries.length;i++)
      {
        //console.log("# "+entries[i].id );

        if(animation)
        {        
          if( ( (entries[i].type == 'Animation') || (entries[i].type == 'Boucle') ) && (_s == true)  )
          {
            this.props.logFn("  App:getNextState:found Animation: "+chapitres[c].num+" / "+entries[i].id);
            return { c: chapitres[c], e: entries[i] };
          }
        }
        else if(_s == true) 
        {
            this.props.logFn("  App:getNextState:found : "+chapitres[c].num+" / "+entries[i].id);
            return { c: chapitres[c], e: entries[i] };
        }
        //console.log("IF "+entries[i].id+"="+_id);

        if(entries[i].id == _id) _s = true;      
      }

    }
    return false;
  }


  gotoNextState = () =>
  {
    /* prepare le prochain id */ 
    this.props.logFn("App:gotoNextState() >> getNextState");    
    let next = this.getNextState();

    if(next)
    {      
      /* EST-CE NECESAIRE OU PAS ?*/
      window.setTimeout( () => {
        // need a setTimeout pour sortir du "thread" courant, et permettre à React de faire les setState 
        this.doAppState( next );
      }, 0 ); // dès que possible
      
      return true;
    }else 
    {
      this.props.logFn("  App:gotoNextState() !! NOT FOUND NEXT STATE");          
      return false;
    }
  }

  cleanState = () =>
  {
    this.setState( { menuOpen: false } );
    this.setState( { titragesAnims: false } );
    this.setState( { interaction: false, interactionAction: null } );
    this.setState( { basedoc: false, baseDocMarkers: [] } );
    this.setState( { basedocPopupOpen: false, popupContent: false } );    
  }

  /* THE BIG STUFF HERE -------------------------------------------------------------------------- */
  

  doAppState = ( s , reset) =>
  {
    this.props.logFn("App:doAppState("+s.c.num+" / "+s.e.id+")");

    let currentVideo = 'videos/CH0' + s.c.num + '/' + s.e.id.substr(1,2) + '/' + s.e.id +'.mp4'; 

    /* cas de la veille, ou du menu */
   
    if(reset == true)  
    {
       // remet la video
      this.setState( { currentChapitre: s.c, currentState : s.e, currentVideo: currentVideo } );
      this.props.logFn("  App:doAppState() RESTART >> set first entrie to :" + s.c.num + " / "+ s.e.id + " / currentVideo: "+currentVideo );
    }


    switch(s.e.type) 
    {      
      case 'Animation':
      {                  
        this.props.logFn("  App:doAppState() >> Animation");

        this.props.logFn("  App:doAppState() >> setState(currentVideo: "+currentVideo+" ,loop:false) = play video & preload currentVideo");      
          
        //this.cleanState(); // pas ici, sinon l'interactif précédent disparait avant le lancement de la prochaine vidéo
        this.setState( { currentChapitre: s.c, currentState : s.e, currentVideo: currentVideo,  loop: false, onReadyVideo: () =>
        {
            this.props.logFn("  App:doAppState() > _onReadyVideo(animation)");
            // lance le titrage quand la video est prête à être jouée
            if(s.e.anim_titrage) this.setState( { titragesAnims : s.e.anim_titrage } );                  

        },onEndVideo: () => 
        {
          /* setState 'Boucle' après 'Animation' */
          this.props.logFn("  App:doAppState() > _onEndVideo")
          this.setState( { positionTime : false } );
          let r = this.gotoNextState();  // Donc interaction ou base doc
          
          // cas de la fin
          if(!r)  this.setState({menuOpen: true});  
            
        } } );
        this.cleanState(); // on le passe après le lancement de la lecture de vidéo, pour hider l'interactif précédent

      };break;
     
      case 'Boucle':
      {
        this.props.logFn("  App:doAppState() >> Boucle");

        this.props.logFn("  App:doAppState() >> setState(currentVideo: "+currentVideo+" ,loop:true) = play video & preload currentVideo");

        //this.cleanState(); // ####  est-ce nécessaire ?
        this.setState( { currentChapitre: s.c, currentState : s.e, currentVideo: currentVideo,  loop: true, onReadyVideo: () =>
        {
            this.props.logFn("  App:doAppState() > _onReadyVideo (boucle)");
            // lance le titrage quand la video est prête à être jouée
            if(s.e.anim_titrage) this.setState( { titragesAnims : s.e.anim_titrage } );                  

            this.gotoNextState();

        }, onEndVideo: null } );
        
        /* on ne bloque pas la stateMachine, la suite doit être une interaction */

      };break;

      case 'Interaction':
      {
        this.props.logFn("  App:doAppState() >> Interaction")
      
        /* on bloque ici la stateMachine, jusqu'a l'interaction */
        
        //this.setState( { titragesAnims: false } );  // non ! sinon on fait disparaitre les titres
        this.setState( { currentChapitre: s.c, currentState : s.e, interaction : true, interactionAction:  () => {
          /* a la fin ou au déclenchement de l'interaction */

          const interaction = window.g_CONFIG_UI.interactions[s.e.id];
          if(interaction)   this.playSound(interaction.sound);

          this.props.logFn("  App:doAppState() > interactionAction fired")
          //this.cleanState();
          this.gotoNextState();
        } } );
        //this.setState( { currentVideo: false } );      /* pour prévenir le cas An > Cn ou l'on va dans le menu pour relancer la vidéo An (bloquée sinon, car par de shouldComponentUpdate:play() ) */ 
        
        // lance le titrage
        if(s.e.anim_titrage) this.setState( { titragesAnims : s.e.anim_titrage } );                  
    

      };break;
     
      case 'Base doc':
      {
        this.props.logFn("  App:doAppState() >> Base doc");

        // ajoute des markers

        let popupContent = { typePopup: s.e.media_type, titrePopup : s.e.bd_titre, textePopup : s.e.bd_texte, mediasPopup : s.e.bd_medias, creditsPopup : s.e.bd_credits  }
        
        const cfg = window.g_CONFIG_UI;
        if(cfg.bd[s.e.id].x == undefined)  this.props.logFn("  App:doAppState() #### ERROR, no coordinate for marker "+s.e.id);

        /* on créer un marker, mix de data_config.js et de config_UI */
        let { baseDocMarkers } = this.state;
        baseDocMarkers.push(  // ajoute un marker dans la liste
          {
            action : () => {  /* when touch */
              this.props.logFn("  App:doAppState() > basedocMarker Action fired");  
              this.setState( { basedocPopupOpen : true, popupContent: popupContent } );  
              
              this.playSound('marker');
            },       
          t : s.e.bd_titre,  // titre du marker affiché 
          cfg: cfg.bd[s.e.id],
          type: s.e.media_type
        });

        /* on ne bloque pas la stateMachine, normalement il doit y avoir d'autres markers pour finir sur une interaction à suivre */

        this.setState( { currentChapitre: s.c, currentState : s.e, basedoc : true, baseDocMarkers: baseDocMarkers } );        // affiche la base doc
        this.gotoNextState(); // va à la suite : autres marker ou interaction suivante obligatoirement 
      };break;
      
      default:this.props.logFn("## ERROR App:doAppState() next.type inconnu :", s.e.type);break;
    }



  }



  /* -------------------- */

  _onClickMenu = () => {
    this.props.logFn("App:_onClickMenu()")

    this.playSound('menu');

    this.setState({menuOpen: true});
  }

  _onClickCloseMenu = () => {
    this.props.logFn("App:_onClickCloseMenu()")
    this.setState({menuOpen: false});
  }  


  _onExitBasedocPopup = () => {
    // à la sortie d'une popup base doc 
    this.setState( { basedocPopupOpen: false } );

    // TODO >> A REVOIR >> Fermeture des markers
    //this.setState( { basedoc : false } );
    //this.gotoNextState();

  }

  /* -------------------- */

  getMarkerStateFromInteractif(id)
  {
    // return 'block';
    return {display: 'none', x:0,y:0 };
  }


  /* -------------------- */

  _entreeEnVeille = () => {
    this.props.logFn("App:_entreeEnVeille()")
    this.cleanState();
    this.setState({enVeille: true});
  }

  _sortieDeVeille = () => {
    this.props.logFn("App:_sortieDeVeille()")
    this.setState({enVeille: false, currentState: false});
    
    this.gotoAppState('A01'); //restart

  }

  _resetTempoVeille = () => {
    this.setState({resetTempoVeilleData: Math.random()})
  }

  /* sons d'interaction */

  initSounds = () =>
  {
    this.sounds = 
    {
      'marker' : new Howl({ src: ['Sounds/marker.mp3'] }),
      'menu'   : new Howl({  src: ['Sounds/menu.mp3']  })
    };

    // ajout les sons d'interaction
    const isounds = window.g_CONFIG_UI.interaction_sounds;
    for(let i=0;i<isounds.length;i++)
      this.sounds[ isounds[i] ] = new Howl({  src: ['Sounds/'+isounds[i]+'.mp3']  }) ;
    
      //console.log('###########', this.sounds);
  }

  playSound = (snd) =>
  {
    this.props.logFn("App:playSound() : ",snd);

    if(this.sounds &&  this.sounds[snd] )
    {
       
      this.sounds[snd].play();
    }
  }

  stopSound = (snd) =>
  {
    this.props.logFn("App:stopSound() : ",snd);

    if(this.sounds &&  this.sounds[snd] )
    { 
      this.sounds[snd].stop();
    }
  }
  

}


/* ----------------------- out of THIS world .... ----------------------- */


/* composants graphiques */

function Timeline( { state } )
{
  const chapitres = window.g_DATA_CONFIG;
  const config = window.g_CONFIG_UI;

  let timeline = [];

  let cl = 'timeline_block';

  for(let c in chapitres)
  {
    let entries = chapitres[c].entries; 
    
    let style = { backgroundColor : config.chapitres_colors[chapitres[c].num - 1] };

    for(let e in entries)
    {
      if( ( entries[e].type == "Animation") || ( entries[e].type == "Boucle" ) )
        timeline.push( <div className={ cl } key={ entries[e].id } style={style} ></div> ); //key={entries[e].id} 

      if(entries[e].id == state)  // si c'est l'entrée courante, on hide les suivantes
        cl = 'timeline_block_transp';
    }
  }

  return <div className='timeline'> { timeline }</div>;
}


function ButtonMenu({onClick})
{
  return <div className="icon_menu" onClick={onClick}>
          <div className="triangle_bkg_menu"></div>
          <div className="icon_triangle_menu"></div>
        </div>
}




export default Ecran180;



// WEBPACK FOOTER //
// ./src/Ecran180.js